     import React from 'react';

import Layout from '../components/layout';
import Slider from '../components/slider';
import { Box, Text, Stack, _hover, Flex } from '@chakra-ui/core';
import PageWrapper from '../components/page.wrapper';

import {
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaGithub,
    FaEnvelope,
    FaPhoneAlt,
    FaMapMarkerAlt,
    FaInstagram,
} from 'react-icons/fa';

const img = require('../images/innerbanner.jpg');
const imgNew = require('../images/carehome/Consultation2.jpg');
 

const DoctorEConsultation = () => (
    <Layout>
        <Box className="sub-menu">
            <Box className="sub-banner" style={{ backgroundImage: `url(${img})` }} />
            <Box className="content-row">
				<h1>Doctor-E-Consultation</h1>
                <Flex align="center" className="flex-row">
                    <Box flex="1" p="4">
                        <Box as="img" src={imgNew} w="100%" />
						 
                    </Box>

                    <Box flex="1" p="4"  className="brief-para">
                        <p>
                            Provide Doctor E Consultation for multi health issues across all age groups , and managing lifestyles related health disorders  and providing guidance on preventive health checks by experienced medical experts.
                        </p>
						 
                    </Box>
                </Flex>
            </Box>
        </Box>
    </Layout>
);

export default DoctorEConsultation;